import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, IUser } from 'models';
import { getKsdmConfig } from 'helpers/index';

const initialState: AuthState = {
  // Seed from the server-injected config so the app knows the user immediately.
  user: (getKsdmConfig()?.user as IUser | null) ?? null,
  loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser | null>) => {
      state.user = action.payload;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setUser, setUserLoading } = authSlice.actions;
export default authSlice.reducer;
